import { render } from "./DeviationCancelTable.vue?vue&type=template&id=3512cdf0"
import script from "./DeviationCancelTable.vue?vue&type=script&lang=ts"
export * from "./DeviationCancelTable.vue?vue&type=script&lang=ts"
script.render = render

export default script